/**
 * Compile-time literal union of all valid Deal field IDs.
 *
 * Derived from the `satisfies`-typed field maps in `./fields/*.ts`.
 * Used to narrow `SavedViewConfig.visibleColumns` so typos in saved views
 * are caught by `tsc`.
 */
import { coreDealsFields } from "./fields/deal-fields-identity";
import { financialDealsFields } from "./fields/deal-fields-financial";
import { companyDealsFields } from "./fields/deal-fields-company";
import { metadataDealsFields } from "./fields/deal-fields-metadata";
import { timelineDealsFields } from "./fields/deal-fields-timeline";
import { contactDealsFields } from "./fields/deal-fields-people";
import { projectHealthDealsFields } from "./fields/deal-fields-project-health";

/**
 * Combined record of all deal fields. The `satisfies` annotations on each
 * source map preserve their literal keys, so `keyof typeof DEAL_FIELDS`
 * resolves to the full union of deal field IDs.
 */
export const DEAL_FIELDS = {
  ...coreDealsFields,
  ...companyDealsFields,
  ...financialDealsFields,
  ...contactDealsFields,
  ...metadataDealsFields,
  ...timelineDealsFields,
  ...projectHealthDealsFields,
};

/** Literal union of every valid deal field id. */
export type DealFieldId = keyof typeof DEAL_FIELDS;
